module.exports = __webpack_public_path__ + "img/Embers-Adrift-2022-003.c774bdcf.jpg";